import React from 'react'
import { Link } from 'react-router-dom'

function Navbar() {
    return (
        <nav class="navbar navbar-expand-lg navbar-dark d-flex flex-column" style={{ backgroundColor: '#BB4C4B', color: '#fff' }} >
            <div class="container-fluid">
                <div className="container d-flex justify-content-center align-items-center">
                    <img src="/assets/logo.png" alt="logo" style={{ width: '45px', margin: '0 10px 0 0' }} />
                    <Link to='/' class="navbar-brand fw-bold" style={{ letterSpacing: '1.5px' }} >CARACTERIZACIÓN INICIAL DE LA RED DE VALOR DE LOS BERRIES Y CHERRIES EN LA REGIÓN DEL BIOBÍO</Link>
                </div>
            </div>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <Link to='/' class="nav-link">Sintesis de Resultados</Link>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Identificaci&oacute;n del productor
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li>
                                <Link to='caracterizacion' class="dropdown-item">Caracterizaci&oacute;n de la Producci&oacute;n</Link>
                            </li>
                            <li>
                                <Link to='actividad' class="dropdown-item" href="#">Identificacion de la Actividad del Productor</Link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <Link to='identificacion-procesos' class="nav-link">Identificacion de Procesos Efectuados</Link>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Caracterizaci&oacute;n de Actividades
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li>
                                <Link to='preparacion-terreno' class="dropdown-item">Preparacion de Terreno</Link>
                            </li>
                            <li>
                                <Link to='manejo-plantas' class="dropdown-item">Manejo de Plantas</Link>
                            </li>
                            <li>
                                <Link to='cosecha' class="dropdown-item">Cosecha</Link>
                            </li>
                            <li>
                                <Link to='venta' class="dropdown-item">Venta</Link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <Link to='descargas' class="nav-link">Descarga de Recursos</Link>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar
